import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useMediaQuery } from '@mui/material';
import { ReactComponent as DetailIcon } from 'src/Images/icons/common/detailIcon.svg';
import { formatFieldValue } from 'src/components/Vehicle/Detail/utils';

function DetailField({ label, value }) {
  return (
    <Col xs={6} sm={6} md={3} lg={3} xl={3}>
      <div className="div-flex-column rg-5">
        <span className="text-sm-outfit secondary-text-grey">{label}</span>
        <span className="text-sm-outfit text-medium-bold">
          {formatFieldValue(value)}
        </span>
      </div>
    </Col>
  );
}

function SectionHeader({ title }) {
  const isMobile = useMediaQuery('(max-width:767px)');
  const themeColor = useSelector(
    (state) => state.AuthReducer?.userData?.tenant?.theme,
  );

  return (
    <div
      className={`div-flex-row ${
        isMobile
          ? 'div-align-center border-bottom vertical-padding-10 horizontal-padding-10'
          : 'border-top border-bottom div-space-between div-align-center vertical-padding-5 horizontal-padding-10'
      }`}
    >
      {isMobile ? (
        <div className="div-flex-row div-align-center cg-10">
          <DetailIcon
            className={`theme-card-header-${themeColor} icon-size-sidebar vehicle-detail-icon`}
          />
          <div className="text-md-outfit text-medium-bold">{title}</div>
        </div>
      ) : (
        <>
          <div className="text-md-outfit text-medium-bold">{title}</div>
          <DetailIcon
            className={`theme-card-header-${themeColor} icon-size-sidebar vehicle-detail-icon`}
          />
        </>
      )}
    </div>
  );
}

function DetailSection({ title, fields }) {
  const isMobile = useMediaQuery('(max-width:767px)');

  return (
    <div className="div-flex-column">
      <SectionHeader title={title} />
      <Row
        className={`m-0 rg-20 ${
          isMobile ? 'vertical-padding-10' : 'vertical-padding-20'
        }`}
      >
        {fields.map((field) => (
          <DetailField
            key={field.label}
            label={field.label}
            value={field.value}
          />
        ))}
      </Row>
    </div>
  );
}

export default function VehicleDetailTab({ vehicle }) {
  const basicFields = [
    {
      label: 'Vehicle Number',
      value: vehicle?.vehicleNumber,
    },
    {
      label: 'Brand',
      value: vehicle?.brand,
    },
    {
      label: 'Model',
      value: vehicle?.model,
    },
    {
      label: 'Fuel Type',
      value: vehicle?.fuelType?.name,
    },
    {
      label: 'Registration Date',
      value: vehicle?.registrationDate,
    },
    {
      label: 'VIN',
      value: vehicle?.vin,
    },
    {
      label: 'Colour',
      value: vehicle?.colour,
    },
    {
      label: 'Capacity',
      value: vehicle?.capacity,
    },
    {
      label: 'Vehicle Type',
      value: vehicle?.vehicleType?.name,
    },
    {
      label: 'Status',
      value: vehicle?.status?.name,
    },
  ];

  const documentFields = [
    {
      label: 'Registration Certificate',
      value: vehicle?.registrationCertificate,
    },
    {
      label: 'Puc Number',
      value: vehicle?.pucNumber,
    },
    {
      label: 'Puc Validity Start Date',
      value: vehicle?.pucValidityStartDate,
    },
    {
      label: 'Puc Validity End Date',
      value: vehicle?.pucValidityEndDate,
    },
    {
      label: 'Insurance Number',
      value: vehicle?.insuranceNumber,
    },
    {
      label: 'Insurance Start Date',
      value: vehicle?.insuranceStartDate,
    },
    {
      label: 'Insurance End Date',
      value: vehicle?.insuranceEndDate,
    },
    {
      label: 'Fitness Certificate Number',
      value: vehicle?.fitnessCertificateNumber,
    },
    {
      label: 'Fitness Certificate Start Date',
      value: vehicle?.fitnessCertificateStartDate,
    },
    {
      label: 'Fitness Certificate End Date',
      value: vehicle?.fitnessCertificateEndDate,
    },
  ];

  return (
    <div className="div-flex-column">
      <DetailSection title="Basic detail" fields={basicFields} />
      <DetailSection title="Document detail" fields={documentFields} />
    </div>
  );
}
